import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import { wsGetAll } from 'services/WService';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

//reemplazando valores de iniciales en estado

export default function ModalBossSupervisor(props) {
  const bossSupervisor = props.model;

  return (
    <Modal
      title="Nuevo Jefe Supervisor"
      model={bossSupervisor}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="base/boss-supervisor"
      state
    >
      <TextField
        label="Código"
        name="code"
        margin="normal"
        fullWidth
        defaultValue={bossSupervisor?.code || ''}
        InputProps={{
          readOnly: true,
        }}
        disabled
      />
      <TextField
        label="Nombre"
        name="name"
        margin="normal"
        fullWidth
        defaultValue={bossSupervisor?.name || ''}
        required
      />
      <TextField
        label="DNI"
        name="dni"
        margin="normal"
        fullWidth
        defaultValue={bossSupervisor?.dni || ''}
        onKeyPress={(e) => {
          var key = window.event ? e.which : e.keyCode;
          if (key < 48 || key > 57) {
            return e.preventDefault();
          }
        }}
        inputProps={{
          maxLength: 8,
          minLength: 8,
        }}
        required
      />
      <TextField
        label="Celular"
        fullWidth
        type="text"
        name="phone"
        margin="normal"
        onKeyPress={(e) => {
          var key = window.event ? e.which : e.keyCode;
          if (key < 48 || key > 57) {
            return e.preventDefault();
          }
        }}
        inputProps={{
          maxLength: 9,
          minLength: 9,
        }}
        defaultValue={bossSupervisor?.phone || ''}
      />
    </Modal>
  );
}
